import { DatePicker, Form } from "antd";
import type { Dayjs } from "dayjs";
import React, { CSSProperties } from "react";
import { getSelectPlaceholderMessage } from "../../../../libs/form";
import { DATE_FORMATS } from "../../../../libs/utils";

const DUE_DATE_FIELD_NAME = "due date";

type DueDatePickerProps = {
  value: Dayjs | null;
  onChange: (date: Dayjs | null) => void;
  width?: number;
  style?: CSSProperties;
};

const labelStyle: CSSProperties = {
  display: "block",
  marginBottom: 8,
  fontSize: 14,
  lineHeight: 1.5715,
  color: "rgba(0, 0, 0, 0.88)",
};

export const DueDatePicker = (props: DueDatePickerProps) => {
  const { value, onChange, width = 180, style } = props;

  return (
    <div style={{ width, height: 86 }}>
      <label style={labelStyle}>Due Date</label>
      <Form.Item style={{ marginBottom: 0 }}>
        <DatePicker
          style={{ width: "100%", borderRadius: 8, ...style }}
          format={DATE_FORMATS.display}
          placeholder={getSelectPlaceholderMessage(DUE_DATE_FIELD_NAME)}
          value={value}
          onChange={onChange}
          allowClear
        />
      </Form.Item>
    </div>
  );
};
